<template>
  <div class="container">
    <v-card>
      <v-card-title class="blue accent-1 gray--text">Control de movimientos en patio (por camión)</v-card-title>
      <v-card-text>
        <v-row class="mx-1">
          <v-col cols="2">
             <p class="text-right black--text">Día a revisar</p>
          </v-col>
          <v-col cols="3">
            <date-picker 
              placeholder="Fecha" 
              class="dtpicker" 
              v-model="start_date" 
              format="DD-MM-YYYY" 
              valueType="YYYY-MM-DD"
              @change="loadMovements">
            </date-picker>
          </v-col>
          <v-col cols="3">
            <v-btn @click="download" color="primary">Excel</v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field
                v-model="movSearch"
                append-icon="mdi-magnify"
                label="Escriba para filtrar movimientos"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="movimientosListHeaders"
          :items="movimientosListBody"
          class="elevation-3"
          dense
          no-data-text="No hay movimientos"
          :search="movSearch"
          :hide-default-footer="true"
          disable-pagination
          fixed-header
          :height="table_height"
        >
          <template v-slot:[`item.bins`]="{ item }">
            <p>{{ item.bins }}</p>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/es';

  export default {
    data: () => ({
        movSearch: null,
        start_date: new Date().toISOString().substr(0, 10),
        isLoading: false,
        url_excel: '',
        table_height: 600,
        movimientosListHeaders: [
        {
          text: 'Turno',
          align: 'center',
          sortable: true,
          value: 'turno',
          width: '100px',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Patente',
          align: 'center',
          sortable: true,
          value: 'patente',
          width: '100px',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Procedencia',
          align: 'left',
          sortable: true,
          value: 'procedencia',
          width: '400px',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Color / Litros',
          align: 'center',
          sortable: true,
          value: 'tipo',
          width: '100px',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Guia',
          align: 'center',
          sortable: true,
          value: 'guia',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Cantidad',
          align: 'center',
          sortable: true,
          value: 'cantidad',
          class: "salmon black--text elevation-3"
        },
        {
          text: 'Lista de bins',
          align: 'left',
          sortable: true,
          value: 'bins',
          class: "salmon black--text elevation-3"
        },
      ],
      movimientosListBody: [],
    }),
    mounted() {
      this.loadMovements();
    },
    methods:{
      async loadMovements(){
        this.mostrarLoading('Generando informe, por favor espere...');
        let url = `${this.base_url}reports/movimientos/camiones/${this.start_date}`;
        await this.axios.get(url, this.headers).then((response)=>{
            this.movimientosListBody = response.data.data.report_data;
            this.url_excel = this.storage_url + response.data.data.url_excel;
            this.ocultarLoading();
        }).catch((error)=>{
            console.log(error);
            this.ocultarLoading();
        });
      },
      download(){
        window.location.href = this.url_excel;
      },
      ...mapMutations(['actualizarBaseUrl', 'actualizarUrlStorage', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['authenticated', 'loading', 'base_url', 'storage_url', 'headers'])
    },
    components:{
      DatePicker
    }
  }
</script>